import HTTP from './axios';

const PatientDependentService = {
  get: patientId => HTTP.get(`/patients/${patientId}/dependents`).then(response => response.data.data),
  getFamily: patientId => HTTP.get(`/patients/${patientId}/family`).then(response => response.data.data),
  getAll: patientId => HTTP.get(`/patients/${patientId}/dependents`).then(response => response.data.data),
  one: (patientId, dependentId) => HTTP.get(`/patients/${patientId}/dependents/${dependentId}`).then(response => response.data.data),
  create: dependents => HTTP.post('/patients/dependents', dependents).then(response => response.data.data),
  update: dependents => HTTP.put('/patients/dependents', dependents).then(response => response.data.data),
  unlink: (patientId, dependentId) => HTTP.put(`/patients/${patientId}/dependents/${dependentId}/unlink`).then(response => response.data.data),
};

export default PatientDependentService;
